import { RadioGroup as R } from 'radix-ui';

import { cx } from '@/lib/cx';

export interface OpcaoSegmentado<T extends string> {
  valor: T;
  rotulo: string;
  /** Uma linha curta que diferencia a opção (lida junto com o rótulo). */
  descricao?: string;
}

interface SegmentadoProps<T extends string> {
  rotulo: string;
  opcoes: readonly OpcaoSegmentado<T>[];
  valor: T;
  aoMudar: (valor: T) => void;
  disabled?: boolean;
}

/**
 * Escolha única entre poucos modos, lado a lado (radiogroup do Radix: setas trocam, Tab sai).
 * No celular, empilha. Para listas, use o Select.
 */
export function Segmentado<T extends string>({
  rotulo,
  opcoes,
  valor,
  aoMudar,
  disabled,
}: SegmentadoProps<T>) {
  return (
    <R.Root
      aria-label={rotulo}
      value={valor}
      onValueChange={(v) => {
        const opcao = opcoes.find((o) => o.valor === v);
        if (opcao) aoMudar(opcao.valor);
      }}
      disabled={disabled ?? false}
      className="grid gap-1 rounded-cartao border border-borda bg-superficie-afundada p-1 sm:auto-cols-fr sm:grid-flow-col"
    >
      {opcoes.map((o) => (
        <R.Item
          key={o.valor}
          value={o.valor}
          className={cx(
            'grid cursor-pointer gap-0.5 rounded-controle px-3 py-2 text-left transition-[background-color,box-shadow,color] duration-[var(--duracao-rapida)]',
            'border border-transparent text-texto-suave enabled:hover:text-texto',
            // Selecionado: borda de tinta, não só a troca de fundo (contraste de 3:1, WCAG 1.4.11).
            'data-[state=checked]:border-marca data-[state=checked]:bg-superficie data-[state=checked]:text-texto data-[state=checked]:shadow-baixa',
            'focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-marca-suave disabled:cursor-not-allowed disabled:opacity-60',
          )}
        >
          <span className="text-sm font-medium">{o.rotulo}</span>
          {o.descricao && <span className="text-xs text-texto-fraco">{o.descricao}</span>}
        </R.Item>
      ))}
    </R.Root>
  );
}
